<template>
  <div
    class="html_teamPlayerInfor_double"
    :class="isPlayer ? '' : 'allCenter'"
    v-if="datas.objectInfo && datas.objectInfo.length == 2"
  >
    <div class="img-box-left">
      <AbPlayerImg
        v-if="isPlayer"
        :playerImg="homeInfor.playerImg"
        :playerNum="homeInfor.playerNum"
        :playerName="`${homeInfor.playerName} ${
          homeInfor.position ? '(' + homeInfor.position + ')' : ''
        }`"
        :countryImg="homeInfor.countryImg"
        :countryName="homeInfor.countryName"
        :countryLogoSize="countryLogoSize"
      ></AbPlayerImg>
      <AbCountry
        v-else
        :countryImg="homeInfor.countryImg"
        :countryName="homeInfor.countryName"
      ></AbCountry>
    </div>
    <div class="items-box" v-if="lists && lists.length > 0">
      <div class="item" v-for="(item, index) in lists" :key="index">
        <span
          class="homeVal"
          v-text="_valFormatHandler(item.homeVal, item.suffix)"
        ></span>
        <span class="title" v-text="item.title"></span>
        <span
          class="awayVal"
          v-text="_valFormatHandler(item.awayVal, item.suffix)"
        ></span>
      </div>
    </div>
    <div class="img-box-right">
      <AbPlayerImg
        v-if="isPlayer"
        :playerImg="awayInfor.playerImg"
        :playerNum="awayInfor.playerNum * 1"
        :playerName="`${awayInfor.playerName} ${
          awayInfor.position ? '(' + awayInfor.position + ')' : ''
        }`"
        :countryImg="awayInfor.countryImg"
        :countryName="awayInfor.countryName"
        :countryLogoSize="countryLogoSize"
      ></AbPlayerImg>
      <AbCountry
        v-else
        :countryImg="awayInfor.countryImg"
        :countryName="awayInfor.countryName"
      ></AbCountry>
    </div>
  </div>
</template>

<script>
// 球员数据对比
import AbCountry from '../components/AbCountry.vue'
import AbPlayerImg from '@components/compreSportsMeet/html/components/PlayerImg.vue'
export default {
  name: 'html_teamPlayerInfor_double',
  props: {
    // 必传参数，所有的数据
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
    isPlayer: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {}
  },
  created() {},
  components: {
    AbCountry,
    AbPlayerImg,
  },
  computed: {
    homeInfor() {
      let homeInfor = {
        playerImg: '',
        playerNum: '',
        playerName: '',
        countryName: '',
        countryImg: '',
        position: '',
      }

      if (this.datas.objectInfo && this.datas.objectInfo[0]) {
        const teamInfor = this.datas.objectInfo[0]
        homeInfor = {
          playerImg: teamInfor.playerInfos[0]
            ? teamInfor.playerInfos[0].profilePicture
            : '',
          playerNum: teamInfor.playerInfos[0]
            ? teamInfor.playerInfos[0].shirtNumber
            : '',
          playerName: teamInfor.playerInfos[0]
            ? teamInfor.playerInfos[0].playerName
            : '',
          countryName: teamInfor.teamName,
          countryImg: teamInfor.teamLogo,
          position: teamInfor.playerInfos[0]
            ? teamInfor.playerInfos[0].position
            : '',
        }
      }
      console.debug('playerInfor:', this.datas, homeInfor)
      return homeInfor
    },
    awayInfor() {
      let awayInfor = {
        playerImg: '',
        playerNum: '',
        playerName: '',
        countryName: '',
        countryImg: '',
        position: '',
      }
      if (this.datas.objectInfo && this.datas.objectInfo[1]) {
        const teamInfor = this.datas.objectInfo[1]
        awayInfor = {
          playerImg: teamInfor.playerInfos[0]
            ? teamInfor.playerInfos[0].profilePicture
            : '',
          playerNum: teamInfor.playerInfos[0]
            ? teamInfor.playerInfos[0].shirtNumber
            : '',
          playerName: teamInfor.playerInfos[0]
            ? teamInfor.playerInfos[0].playerName
            : '',
          countryName: teamInfor.teamName,
          countryImg: teamInfor.teamLogo,
          position: teamInfor.playerInfos[0]
            ? teamInfor.playerInfos[0].position
            : '',
        }
      }
      return awayInfor
    },
    lists() {
      if (this.datas.data.dataList && this.datas.data.dataList.length == 2) {
        const home = this.datas.data.dataList[0]
        const away = this.datas.data.dataList[1]
        return this.datas.statisticsModels.map((modeItem) => {
          const homeValue = home[modeItem.statisticalEn]
          const awayValue = away[modeItem.statisticalEn]
          // console.debug(
          //   home,
          //   modeItem.statisticalEn,
          //   home[modeItem.statisticalEn]
          // )
          return {
            title: modeItem.name,
            homeVal: homeValue,
            awayVal: awayValue,
            suffix: modeItem.suffix,
          }
        })
      }
      return []
    },
    countryLogoSize() {
      if (
        this.datas &&
        this.datas.sportType === 'basketball' &&
        this.datas.competitionType === 'league'
      ) {
        return ['1.666vw', '1.666vw']
      } else {
        return ['2.498vw', '1.666vw']
      }
    },
  },
  methods: {
    _textFormatHandler(val, text, ceil) {
      let data
      console.debug(val, typeof val)
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = ''
      } else {
        if (text) {
          data = `${text} ${val}${ceil ? ceil : ''}`
        } else {
          data = val
        }
      }
      console.debug(val, data)
      return data
    },
    _valFormatHandler(val, ceil) {
      let data
      console.debug(val, typeof val)
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = ''
      } else {
        if (val && ceil) {
          data = `${val}${ceil ? ceil : ''}`
        } else {
          data = val
        }
      }
      // console.debug(val, data)
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.html_teamPlayerInfor_double {
  /* margin: 0 auto; */
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  &.allCenter {
    align-items: center;
  }
  .items-box {
    width: calc(100% - 16vw);
    .item {
      width: 100%;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: center;
      height: 1.944vw;
      padding: 0 0.694vw;
      background-color: var(--mixtmt_subColor_main);
      &:nth-child(2n) {
        background-color: var(--mixtmt_whiteColor);
      }

      .homeVal,
      .awayVal,
      .title {
        font-size: 0.833vw;
        color: var(--mixtmt_greyColor_main);
        width: 6.25vw;
      }
      .homeVal,
      .awayVal {
        width: calc(50% - 3.47vw);
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .title {
        width: 6.94vw;
        text-align: center;
      }
      .awayVal {
        text-align: right;
      }
    }
  }
}
</style>
